import styled, { css } from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import { dropdownBoxStyleOptions } from './constants'

export const DropdownContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`

export const DropdownWrapperContainer = styled.div`
  width: 100%;
`

// Input
export const DropdownInput = styled.input`
  all: unset;
  caret-color: ${colorsOptions.docuToolsOrange.orange};
  width: 100%;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}  
  line-height: normal;
  letter-spacing: normal;
  color: ${colorsOptions.greys['grey-100']};
  background-color: transparent;

  font-feature-settings: 'lnum';
  &[type='password'] {
    font-size: 1.5rem;
    max-height: 24px;
  }

  &::placeholder {
    color: ${colorsOptions.greys['grey-30']};
  }

  &:disabled {
    color: ${colorsOptions.greys['grey-40']};
    background: transparent;
  }
`

export const DropdownInputMulti = styled(DropdownInput)`
  width: 100%;
  flex: 1;
`

export const DropdownInputContainer = styled.div`
  display: flex;
  max-height: 21px;
  align-items: center;
  margin: 0.2rem 0 0.25rem 0;

  ${({ boxStyle }) =>
    boxStyle === dropdownBoxStyleOptions.BOX &&
    css`
      border: 1px solid;
      border-radius: 4px;
      background-color: ${colorsOptions.greys.white};
      max-height: 32px;
      margin: 0;
      padding: 0.25rem;
      border: 1px solid ${colorsOptions.greys['grey-70']};
    `}

  border-bottom: 1px solid ${colorsOptions.greys['grey-70']};

  ${DropdownInput} {
    &[data-read-only='true'] {
      color: ${colorsOptions.greys['grey-70']};
      pointer-events: none;
    }

    background-color: ${({ boxStyle }) =>
      boxStyle === dropdownBoxStyleOptions.BOX
        ? colorsOptions.greys.white
        : 'transparent'};
  }

  &[data-open='true'] {
    border-bottom-width: 1px;
    border-color: ${colorsOptions.greys['grey-100']};
  }

  &:hover {
    border-bottom-width: 1.5px;
    border-color: ${colorsOptions.greys['grey-100']};
  }

  &[data-read-only='true'] {
    border-bottom-width: 1px;
    border-color: ${colorsOptions.greys['grey-20']};
  }

  &[data-disabled='true'] {
    border-bottom-width: 1px;
    border-color: ${colorsOptions.greys['grey-40']};
  }

  ${({ boxStyle }) =>
    boxStyle === dropdownBoxStyleOptions.BOX &&
    css`
      &:hover {
        border-width: 1.5px;

        &[data-read-only='true'],
        &[data-disabled='true'] {
          border-width: 1px;
        }
      }
    `}
`

export const DropdownInputContainerMulti = styled(DropdownInputContainer)`
  align-items: flex-end;

  ${({ notEmptySelectedItems }) =>
    notEmptySelectedItems &&
    css`
      max-height: none;
      padding-bottom: 1.5px;
    `}

  ${({ boxStyle }) =>
    boxStyle === dropdownBoxStyleOptions.BOX &&
    css`
      padding-bottom: 0.25rem;
    `}
`

export const DropdownInputWraper = styled.div`
  flex-wrap: wrap;
  display: flex;
  width: 100%;
  gap: 0.25rem;
`

// Label
export const DropdownLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const DropdownLabelText = styled.span`
  all: unset;
  display: flex;
  align-items: center;
  font-variant-numeric: lining-nums proportional-nums;

  color: ${colorsOptions.greys['grey-50']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]};
  font-weight: 600;
  font-style: normal;
  line-height: 15.6px; /* 130% */
  letter-spacing: 0.2px;

  &[data-disabled='true'] {
    color: ${colorsOptions.greys['grey-40']};
  }
`

// Hint
export const DropdownHintContainer = styled.div`
  display: flex;
  justify-content: start;
`

export const DropdownHintText = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-70']};
`

export const MenuTitleContainer = styled.div`
  padding: 1rem 1rem 0.5rem 1rem;
  background-color: ${colorsOptions.greys.white};
`

export const MenuTitle = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-70']};
`
export const DropdownHeaderSearchContainer = styled.div`
  background-color: ${colorsOptions.greys.white};
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  background-color: ${colorsOptions.greys.white};
`
export const MenuHeaderTabsContainer = styled.div`
  background-color: ${colorsOptions.greys.white};
  width: 100%;
  padding: 0.5rem;
  background-color: ${colorsOptions.greys.white};
`

export const MenuTextPrimary = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`

// Counter

export const ChipsCounterContainer = styled.div`
  padding: 0.25rem;
  background-color: ${colorsOptions.greys.black};
  border: 1px solid ${colorsOptions.greys.black};
  border-radius: 4px;
  align-self: center;
  margin-right: 0.25rem;
`

export const ChipsCounter = styled.span`
  display: flex;
  align-items: center;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  color: ${colorsOptions.greys.white};
`
export const NotFoundContainer = styled.div`
  background-color: ${colorsOptions.greys.white};
  width: 100%;
  text-align: center;
  padding: 1.5rem;
`

export const NotFoundText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-50']};
`

export const DropdownIconContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: 0.25rem;
  align-items: center;
`
